/**
 * Created by r4zi4l on 18.03.2021
 */

const EnergyLottery = function (slot) {
    cleverapps.EventEmitter.call(this);

    this.slot = slot;

    this.onLotteryAttentionChanged = function () {};
    this.onLotteryTileChanged = function () {};

    if (!this.isAvailable()) {
        cleverapps.exp.on("changeExp", () => {
            if (this.isAvailable()) {
                this.onChangeGameLevel();
            }
        }, this);
    }

    this.onShowHint = function () {};
    this.onHideHint = function () {};

    this.load();
    this.update();

    this.calcValues();

    this.canBuyWithGold = ["wondermerge", "fairy"].indexOf(cleverapps.config.name) !== -1 && !connector.platform.oneOf(connector.SP_MOBAGE, connector.MOBAGE);

    this.start();

    cleverapps.gameLevel.on("changeLevel", this.onChangeGameLevel.bind(this), this);
};

EnergyLottery.prototype = Object.create(cleverapps.EventEmitter.prototype);
EnergyLottery.prototype.constructor = EnergyLottery;

EnergyLottery.prototype.showHint = function () {
    this.hint = true;

    this.onShowHint();

    setTimeout(() => {
        this.hint = false;

        this.onHideHint();
    }, 11000);
};

EnergyLottery.prototype.isHintActive = function () {
    return this.hint;
};

EnergyLottery.prototype.onChangeGameLevel = function () {
    this.update();
};

EnergyLottery.prototype.load = function () {
    this.last = 0;

    let stored = this.slot.load("lottery");
    if (!stored) {
        return;
    }

    stored = cleverapps.castType(stored);

    if (typeof stored === "number") {
        this.last = cleverapps.expandTime(stored, { seconds: true });
    } else if (typeof stored === "object") {
        this.last = stored.last || 0;

        // migrate
        if (stored.refreshTime) {
            this.last = stored.refreshTime;
        }
    }
};

EnergyLottery.prototype.save = function () {
    this.slot.save("lottery", cleverapps.compactTime(this.last, { seconds: true }));
};

EnergyLottery.prototype.update = function () {
    this.clearTimeout();

    const ready = this.isReady();
    if (this.ready !== ready) {
        this.ready = ready;
        this.onLotteryAttentionChanged();
        this.onLotteryTileChanged();
    }

    const timeLeft = this.getTimeLeft();
    if (timeLeft > 0) {
        this.timeout = new cleverapps.LongTimeout(this.update.bind(this), timeLeft);
    }
};

EnergyLottery.prototype.destructor = function () {
    this.clearTimeout();
    runCleaners(this);
};

EnergyLottery.prototype.clearTimeout = function () {
    if (this.timeout !== undefined) {
        clearTimeout(this.timeout);
        delete this.timeout;
    }
};

EnergyLottery.prototype.isAvailable = function () {
    return cleverapps.user.checkAvailable(cleverapps.config.availables.ENERGY_LOTTERY);
};

EnergyLottery.prototype.isReady = function () {
    return this.isAvailable() && this.getTimeLeft() <= 0;
};

EnergyLottery.prototype.getTimeLeft = function () {
    return Math.max(0, this.last + cleverapps.parseInterval(EnergyLottery.REFRESH_TIMEOUT) - Date.now());
};

EnergyLottery.prototype.reset = function () {
    this.last = 0;
    this.save();
    this.update();
};

EnergyLottery.prototype.nextValue = function () {
    let value;

    if (this.last === 0) {
        value = { energy: this.maxValue() };
    } else {
        const pseudo = new PseudoRandom("secondary");
        pseudo.randomSeed();
        value = pseudo.choose(this.getValues());
    }

    return value;
};

EnergyLottery.prototype.start = function () {
    this.tries = EnergyLottery.TRIES;

    this.isAnimating = false;
};

EnergyLottery.prototype.play = function (options) {
    if (this.isAnimating) {
        return;
    }

    if (!this.canPlay()) {
        return;
    }

    options = options || {};
    options.amount = this.nextValue();

    if (this.tries === EnergyLottery.TRIES) {
        this.last = Date.now();

        this.save();
        this.update();

        cleverapps.eventBus.trigger("taskEvent", "ENERGY_LOTTERY");
    }

    this.tries--;

    this.isAnimating = true;

    this.trigger("play", options);

    if (this.tries < 1) {
        if (!this.canBuyWithGold) {
            this.finish();
        }
    }
};

EnergyLottery.prototype.onAnimationFinished = function () {
    this.isAnimating = false;

    if (this.canPlay()) {
        this.trigger("prepareNext");
    }
};

EnergyLottery.prototype.finish = function () {
    this.trigger("finish");
};

EnergyLottery.prototype.canPlay = function () {
    return this.tries > 0 || this.canBuyWithGold;
};

EnergyLottery.prototype.maxValue = function () {
    return this.getValues().reduce((best, value) => Math.max(best, value.energy || 0), 0);
};

EnergyLottery.prototype.getValues = function () {
    this.calcValues();
    return this.values;
};

EnergyLottery.prototype.calcValues = function () {
    if (cleverapps.lives.amount < cleverapps.lives.getMaxLives() * 1.5) {
        this.values = [{ energy: 100 }, { energy: 45 }, { energy: 65 }, { energy: 40 }, { energy: 60 }, { energy: 35 }, { energy: 55 }, { energy: 30 }, { energy: 50 }];
        return;
    }
    if (cleverapps.lives.amount < cleverapps.lives.getMaxLives() * 2) {
        this.values = [{ energy: 80 }, { energy: 25 }, { energy: 45 }, { energy: 20 }, { energy: 40 }, { energy: 15 }, { energy: 35 }, { energy: 10 }, { energy: 30 }];
        return;
    }
    this.values = [{ energy: 30 }, { energy: 10 }, { energy: 15 }, { energy: 5 }, { energy: 25 }, { energy: 5 }, { energy: 20 }, { energy: 5 }, { energy: 15 }];
};

EnergyLottery.REFRESH_TIMEOUT = "3 hours";
EnergyLottery.TRIES = 1;

if (cleverapps.config.debugMode) {
    EnergyLottery.REFRESH_TIMEOUT = "1 minute";
}
